<template>
  <div no-body>
    <b-row v-if="lkuLoading" class="justify-content-center mb-2"
      ><span style="color: blue">Loading data ...</span></b-row
    >
    <b-row v-else>
      <b-col lg="11">
        <b-input-group>
          <b-input-group-prepend
            ><span class="p-2">Filter</span></b-input-group-prepend
          >
          <b-form-input
            v-model="tblData.full_name"
            @keyup.13.native="search()"
            placeholder="Full Name"
          ></b-form-input>
          <b-form-input
            v-model="tblData.username"
            @keyup.13.native="search()"
            placeholder="User Name"
            class="ml-1"
          ></b-form-input>
          <b-input-group-append>
            <b-button class="btn btn-success ml-1" @click="search()">
              <i class="fa fa-refresh"></i> Apply Filter</b-button
            >
          </b-input-group-append>
          <b-input-group-append>
            <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table
      class="mb-0"
      ref="tblUsers"
      responsive
      striped
      hover
      small
      style="font-size: smaller"
      :items="data"
      :fields="fields"
      :current-page="tblData.page"
      :per-page="tblData.limit"
      :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit"
      @row-clicked="selectItem"
    >
      <template v-slot:cell(alamat)="data">
        {{ data.item.alamat }} {{ data.item.kota }} {{ data.item.negara }}
      </template>
    </b-table>
    <b-row>
      <b-col cols="4">
        <div class="pt-2">
          Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
          <span v-if="tblData.page * tblData.limit > tblData.total">{{
            tblData.total
          }}</span>
          <span v-else>{{ tblData.page * tblData.limit }}</span> of
          {{ tblData.total }} entries
        </div>
      </b-col>
      <b-col cols="3">
        <b-row class="ml-2 mt-2">
          <span class="pt-1 pr-2">Limit per page</span>
          <b-form-select
            :options="[10, 20, 30, 50, 70, 90, 120]"
            :plain="true"
            v-model="tblData.limit"
            size="sm"
            style="width: 80px !important"
          />
        </b-row>
      </b-col>
      <b-col cols="5">
        <b-pagination
          align="right"
          :total-rows="tblData.total"
          :per-page="tblData.limit"
          v-model="tblData.page"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import auth from "../../apis/auth";

export default {
  data() {
    return {
      fields: [
        {
          key: "full_name",
          label: "Full Name",
          sortable: true,
        },
        {
          key: "company",
          label: "Company Name",
          sortable: true,
        },
        {
          key: "jabatan",
          label: "Job Title",
          sortable: true,
        },
        {
          key: "departemen",
          label: "Department",
          sortable: true,
        },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false,
        username: "",
        full_name: "",
      },
      lkuLoading: false,
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await auth.userClient(this.tblData);
      this.lkuLoading = false;
      return list;
    },
    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    refresh() {
      this.$refs.tblUsers.refresh();
    },
    search() {
      this.tblData.page = 1;
      this.$refs.tblUsers.refresh();
    },
    clearFilter() {
      this.tblData.full_name = "";
      this.tblData.username = "";
    },
  },
};
</script>
